import store from '@/store';
import apiCall from '../apiCall';

/**
 * Unsuspends user account
 *
 * @param {object} instance Vue instance.
 */
export default async (instance) => {
    if (store.state.user.suspended_at) {
        const { status } = await apiCall(instance, 'post', '/api/user/suspension', { suspension: null });

        return (200 === status);
    } else {
        return true;
    }
};
